module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_shinjuku-d258f5965be3dbe0630d29d8b5c696ae.jpg";